import { render, staticRenderFns } from "./addr-sample.vue?vue&type=template&id=5206c678&scoped=true"
import script from "./addr-sample.vue?vue&type=script&lang=js"
export * from "./addr-sample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206c678",
  null
  
)

export default component.exports